import {Post, PostPagination, PostPaginationFilters, Tag} from '@/modules/blog/types'
import { Module } from 'vuex'
import { RootState } from '@/store/types'
import mutations from '@/modules/blog/store/mutations'
import actions from '@/modules/blog/store/actions'
import getters from '@/modules/blog/store/getters'
import store from '@/store';
import {setCurrentMetadata, setCurrentTranslation} from '@/modules/seo/store/subscriptions';

/**
 * Estado del blog
 */
export interface BlogState {

    /**
     * Publicación en edición
     *
     * La publicación actualmente en edición que es mostrada por el componente
     * de edición de artículos del blog
     */
    editingPost: Post

    /**
     * Traducción actual de la publicación en edición
     *
     * Almacena el localismo de la traducción que se encuentra actualmente
     * seleccionada por el usuario en la publicación en edición
     */
    currentTranslation: string

    /**
     * Paginación actual
     *
     * Ultima paginación obtenida desde el servidor
     */
    currentPostPagination: PostPagination

    /**
     * Filtros de la paginación actual
     *
     * Almacena el ultimo filtro de paginación seleccionado por el usuario en
     * la lista de publicaciones
     */
    currentPostPaginationFilters: PostPaginationFilters

    /**
     * Indica si se esta cargando una paginación de publicaciónes del servidor
     */
    postPaginationLoading: boolean,

    /**
     * Indica si la lista de publicaciones o la ficha de una publicación
     * estan eliminando. Esto debe mostrar el dialogo de
     * confirmación
     */
    showPostDeletionConfirm: boolean,

    /**
     * Almacena la publicación seleccionada para eliminar
     */
    postToDelete: Post,

    /**
     * Indica si la pantalla de la publicación debe mostrar el la vista previa
     * del post actual
     */
    postPreviewActive: boolean

    /**
     * Contenido de la vista previa actualmente mostrada al usuario
     */
    currentPostPreview: string,

    /**
     * Indica si el sistema esta cargando la vista previa de la publicación
     */
    loadingPreview: boolean,

    /**
     * Indica si se debe mostrar la pantalla de confirmación para guardar una
     * publicación
     */
    saveConfirm: boolean,

    /**
     * Lista de etiquetas del blog registradas en la aplicación
     */
    tags: Tag[],

    /**
     * Etiqueta actualmente seleccionada por el usuario para su edición, creación o eliminación
     */
    tag: Tag,

    /**
     * Indica si la aplicación ya ha cargado la lista de etiquetas registradas
     */
    tagsFetched: boolean
}

// Registra dos listeners
store.listen('blog/setEditingPost', setCurrentMetadata)
store.listen('blog/setEditingPostCurrentTranslation', setCurrentTranslation)

const module: Module<BlogState, RootState> = {
    namespaced: true,
    actions,
    mutations,
    getters,
    state: {
        editingPost: new Post(),
        currentTranslation: '',
        currentPostPagination: new PostPagination(),
        currentPostPaginationFilters: new PostPaginationFilters(),
        postPaginationLoading: false,
        showPostDeletionConfirm: false,
        postToDelete: new Post(),
        postPreviewActive: false,
        currentPostPreview: '',
        loadingPreview: false,
        saveConfirm: false,
        tags: [],
        tag: new Tag(),
        tagsFetched: false,
    },
}

export default module
